
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compensation",
      function () {
        return require("private-next-pages/compensation.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compensation"])
      });
    }
  